import React from "react"
import { Link as GatsbyLink } from "gatsby"
import { Box, Link as RebassLink, Flex } from "rebass"
import footerLinks from '../constants/footerLinks'

export default props => (
  <Box as="footer" py={5} color="background" bg="text" flexDirection="row">
    <Box
      sx={{
        maxWidth: "wide",
        mx: "auto",
        px: 3,
      }}
    >
      <Flex flexDirection="row" justifyContent="space-between">
        <Box>
          Created by
          <RebassLink
            href="https://swizec.com"
            variant="nav"
            style={{ textDecoration: "underline" }}
          >
            Swizec
          </RebassLink>
          with ❤️
        </Box>
        <Flex
          sx={{
            "a": {
              marginLeft: 2
            }
          }}>
        {
          footerLinks.map((link) => <FooterLink key={link.Title} link={link} />)
        }
        </Flex>
      </Flex>
    </Box>
  </Box>
)

function FooterLink ({ link }) {
  if (link.Link.startsWith("http")) {
    return (
      <RebassLink href={link.Link} variant="nav">{link.Title}</RebassLink>
    )
  } else {
    return (
      <RebassLink as={GatsbyLink} key={link.Link} to={link.Link} variant="nav">
        {link.Title}
      </RebassLink>
    )
  }
}
